import { AnyAction, applyMiddleware, createStore, Dispatch, Middleware, MiddlewareAPI } from 'redux';
import { routerMiddleware } from 'connected-react-router';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunk from 'redux-thunk';

import { routeToSpecificScope } from '../helpers/helpersts';
import { history } from './reducers';
import createRootReducer from './reducers';

export const saveTablePropertiesOnLocalStorage = (store: MiddlewareAPI<Dispatch<AnyAction>, any>) => {
  const reducer = 'tableProperties';
  const recoveredStore = JSON.parse(localStorage.getItem('store') || '{}');
  recoveredStore[reducer] = {};
  const pathname = store.getState().router.location.pathname;
  const scopeForFilter = routeToSpecificScope(pathname);
  // const scopeForFilter = routeToViewPracticeGamePageScope(pathname);
  recoveredStore[reducer][scopeForFilter] = store.getState().tableProperties[scopeForFilter];
  localStorage.setItem('store', JSON.stringify(recoveredStore));
};


const logger: Middleware = store => next => action => {
  // console.debug('dispatching', action);
  const result = next(action);
  if (action.SAVE_LOCAL_STORAGE === 'saveTablePropertiesOnLocalStorage') {
    saveTablePropertiesOnLocalStorage(store);
  }
  // print the size on kB of store
  // console.debug((new TextEncoder().encode(JSON.stringify(store)).length / 1024).toFixed(3) + ' kB');
  // console.debug('next state', store.getState());
  return result;
};

export default function configureStore(/*preloadedState*/) {
  const store = createStore(
    createRootReducer, // root reducer with router state
    // preloadedState,
    // compose(
    composeWithDevTools(
      applyMiddleware(
        routerMiddleware(history), // for dispatching history actions
        logger,
        thunk
      )
    )
  );
  return store;
}
